import React from 'react';
import {
  TableHead,
  TableRow,
  TableCell,
  Box,
} from '@mui/material';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';

const InventoryTableHeader = ({ sortConfig, onSort, shops }) => {
  const getSortIcon = (field) => {
    if (sortConfig.field !== field) {
      return null;
    }
    return sortConfig.direction === 'asc' ? <ArrowUpward fontSize="small" /> : <ArrowDownward fontSize="small" />;
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell 
          sx={{ 
            fontWeight: 600, 
            backgroundColor: 'background.default',
            cursor: 'pointer',
            '&:hover': { backgroundColor: 'action.hover' }
          }}
          onClick={() => onSort('name')}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            Produkt
            {getSortIcon('name')}
          </Box>
        </TableCell>
        <TableCell 
          sx={{ 
            fontWeight: 600, 
            backgroundColor: 'background.default',
            cursor: 'pointer',
            '&:hover': { backgroundColor: 'action.hover' }
          }}
          onClick={() => onSort('externalId')}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            External ID
            {getSortIcon('externalId')}
          </Box>
        </TableCell>
        <TableCell 
          align="center" 
          sx={{ 
            fontWeight: 600, 
            backgroundColor: 'background.default',
            cursor: 'pointer',
            '&:hover': { backgroundColor: 'action.hover' }
          }}
          onClick={() => onSort('quantity')}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            Stan magazynowy
            {getSortIcon('quantity')}
          </Box>
        </TableCell>
        <TableCell 
          align="center" 
          sx={{ 
            fontWeight: 600, 
            backgroundColor: 'background.default',
            cursor: 'pointer',
            '&:hover': { backgroundColor: 'action.hover' }
          }}
          onClick={() => onSort('status')}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            Status
            {getSortIcon('status')}
          </Box>
        </TableCell>
        {shops.map((shop, index) => (
          <TableCell key={shop.id} align="center" sx={{ fontWeight: 600, backgroundColor: 'background.default' }}>
            {shop.name}
          </TableCell>
        ))}
        <TableCell align="center" sx={{ fontWeight: 600, backgroundColor: 'background.default' }}>Akcje</TableCell>
      </TableRow>
    </TableHead>
  );
};

export default InventoryTableHeader; 